import { css, styled } from 'styled-components'

export const LayoutContent = styled.div<{
  $variant?: 'funnel' | 'subscription'
}>`
  position: relative;
  z-index: 2;
  display: flex;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.contentWidth}rem;
  flex: 1;
  flex-direction: column;
  ${({ $variant }) => {
    switch ($variant) {
      case 'subscription':
        return css`
          padding: 1.5rem
            ${({ theme }) => theme.sizes.contentHorizontalPadding}rem;
          gap: 1.5rem;
        `
      case 'funnel':
      default:
        return css`
          padding: ${({ theme }) => theme.sizes.contentHorizontalPadding}rem;
          gap: 1rem;
        `
    }
  }};
`
